import {
  BANK_TRANSFER,
  CASH_DISCOUNT,
  CHEQUE,
  CREDIT_NOTE_DEBIT_NOTE,
  DEBIT,
  LEDGER_SETTLEMENT,
  LOCOFAST_ACCOUNT,
  PAYMENT_MODE,
  TDS,
  UPI
} from './orderConfirmConstant';

export const SUPPLIER_PAYMENT_STATUS_PENDING = 100;
export const SUPPLIER_PAYMENT_STATUS_PAID = 200;
export const SUPPLIER_PAYMENT_STATUS_REJECTED = 400;

export const SUPPLIER_PAYMENT_STATUS_FILTERS = [
  {
    text: 'Pending',
    value: SUPPLIER_PAYMENT_STATUS_PENDING
  },
  {
    text: 'Paid',
    value: SUPPLIER_PAYMENT_STATUS_PAID
  },
  {
    text: 'Rejected',
    value: SUPPLIER_PAYMENT_STATUS_REJECTED
  }
];
export const ORDER_STATUS = {
  5: 'Provisional',
  10: 'In production',
  20: 'Dispatched',
  30: 'Warehouse',
  40: 'Delivered',
  50: 'Cancelled',
  60: 'Terminated'
};

export const ORDER_STATUS_REVERSE = {
  PROVISIONAL: 5,
  CREATED: 10,
  DISPATCHED: 20,
  WAREHOUSE: 30,
  DELIVERED: 40,
  CANCELLED: 50,
  TERMINATED: 60
};

export const PAYMENT_MODE_OPTIONS_FORM_DOMESTIC = [
  {
    paymentMode: PAYMENT_MODE[BANK_TRANSFER],
    id: BANK_TRANSFER
  },
  {
    paymentMode: PAYMENT_MODE[CHEQUE],
    id: CHEQUE
  },
  {
    paymentMode: PAYMENT_MODE[DEBIT],
    id: DEBIT
  },
  {
    paymentMode: PAYMENT_MODE[LOCOFAST_ACCOUNT],
    id: LOCOFAST_ACCOUNT
  },
  {
    paymentMode: PAYMENT_MODE[UPI],
    id: UPI
  },
  {
    paymentMode: PAYMENT_MODE[TDS],
    id: TDS
  },
  {
    paymentMode: PAYMENT_MODE[CREDIT_NOTE_DEBIT_NOTE],
    id: CREDIT_NOTE_DEBIT_NOTE
  },
  {
    paymentMode: PAYMENT_MODE[LEDGER_SETTLEMENT],
    id: LEDGER_SETTLEMENT
  },
  {
    paymentMode: PAYMENT_MODE[CASH_DISCOUNT],
    id: CASH_DISCOUNT
  }
];

export const ENTER_PAYMENT_DETAILS = '1';
export const REJECT = '2';

export const DROPDOWN_MENU_OPTIONS = [
  {
    key: ENTER_PAYMENT_DETAILS,
    name: 'Enter payment details'
  },
  {
    key: REJECT,
    name: 'Reject'
  }
];
export const DISPATCH_STATUS = {
  2: 'Query created',
  3: 'Quotes received',
  ...ORDER_STATUS,
  15: 'Goods ready',
  17: 'Partially dispatched'
};
export const DISPATCH_STATUS_CUSTOMER_PAYMENT = {
  ...ORDER_STATUS,
  15: 'Goods ready',
  17: 'Partially dispatched',
  2: 'New order',
  3: 'New order',
  5: 'New order'
};

export const PAYMENT_TERMS_TYPE = {
  BOOKING: 10,
  DACC: 20,
  DISPATCH: 30,
  DELIVERY: 40
};

export const PAYMENT_TERMS_TYPE_LABELS = {
  [PAYMENT_TERMS_TYPE.BOOKING]: 'booking',
  [PAYMENT_TERMS_TYPE.DACC]: 'DACC',
  [PAYMENT_TERMS_TYPE.DISPATCH]: 'dispatch',
  [PAYMENT_TERMS_TYPE.DELIVERY]: 'delivery'
};

export const PAYMENT_CREDIT_TYPES = {
  OPEN: 10,
  PDC: 20,
  LC: 30
};

export const CREDIT_TYPE_LABELS = {
  [PAYMENT_CREDIT_TYPES.OPEN]: 'Open Credit',
  [PAYMENT_CREDIT_TYPES.PDC]: 'PDC',
  [PAYMENT_CREDIT_TYPES.LC]: 'LC'
};
